import React from 'react';
// import { Link } from 'react-router-dom';
import { PageSettings } from '../../config/page-settings';
import { CloseOutlined } from '@ant-design/icons';

class SidebarProfile extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			profileActive: 0,
			CurrentUserLoginName: localStorage.getItem("loginName"),
			CurrentUserLoginImage: localStorage.getItem("loginUserImage")

		};
		this.handleProfileExpand = this.handleProfileExpand.bind(this);
		// console.log("loginName", localStorage.getItem("loginUserImage"))
	}

	componentDidMount() {
		setInterval(() => {
			this.setState({ CurrentUserLoginName: localStorage.getItem("loginName") })
			this.setState({ CurrentUserLoginImage: localStorage.getItem("loginUserImage") })
		}, 1000);
	}
	handleProfileExpand(e) {
		e.preventDefault();
		this.setState(state => ({
			profileActive: !this.state.profileActive,
		}));
	}

	render() {
		return (
			<PageSettings.Consumer>
				{({ toggleMobileSidebar }) => (
					<ul className="nav">
						<div className='slider-icon-set' onClick={toggleMobileSidebar}><CloseOutlined /></div>
						<li className="nav-profile">
							<div>
								<div className="cover with-shadow"></div>
								<div>
									<img src={this.state.CurrentUserLoginImage}
										onError={({ currentTarget }) => {
											currentTarget.onerror = null; // prevents looping
											currentTarget.src = "../assets/img/new-images/images.png";
										}}
										className="image"
									></img>
									{/* <img src="/assets/img/user/user-13.jpg" alt="" /> */}
								</div>
								<div className="info">
									{this.state.CurrentUserLoginName}
									{/* <small>Front end developer</small> */}
								</div>
							</div>
						</li>
					</ul>
				)}
			</PageSettings.Consumer>
		)
	}
}

export default SidebarProfile;